import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'fleetoperate-driver-personal-information',
  templateUrl: './driver-personal-information.component.html',
  styleUrls: ['./driver-personal-information.component.scss']
})
export class DriverPersonalInformationComponent implements OnInit {

  @Input() group: FormGroup;
  
  constructor() { }

  ngOnInit() {
  }

}
